import React from "react";
import FaqItem from "./compomemts/FAQItem";
import useController from "./controller";
import BasePage from "../../components/BasePage";
import { useTranslation } from "../../locales";
import "./style.scss";

export default function PageFAQ() {
  const { t } = useTranslation();
  const { faqList, loading } = useController();

  return (
    <BasePage className="page-faq" loading={loading}>
      <h1 className="page-faq__title">{t("Frequently Asked Questions")}</h1>
      <div className="page-faq__content">
        {faqList.map((el, i) => (
          <FaqItem className={"mb-3"} key={i} item={el} />
        ))}
      </div>
    </BasePage>
  );
}
